import React, { useState } from "react";

/**
 * Off-screen field a human never sees or tabs into. Bots that blindly fill every
 * input give themselves away, and the backend silently drops those submissions.
 */
export function useHoneypot() {
  const [value, setValue] = useState("");

  const HoneypotField = (
    <div
      aria-hidden="true"
      style={{ position: "absolute", left: "-9999px", width: 1, height: 1, overflow: "hidden" }}
    >
      <label htmlFor="nq-website">Website</label>
      <input
        id="nq-website"
        name="website"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );

  return { honeypot: value, HoneypotField };
}
